import React from "react";

export const PlayerAudioCallbackContext = React.createContext({
    assignMediaRef: null,
    playPauseAudio: null,
});
